module.exports = __webpack_public_path__ + "static/media/image_2.a5eb78a5.png";